export const messages = {
  select: 'Select',
  reset: 'Reset',
};
